<template>
  <div>
    <!--begin::Dashboard-->
    <!-- <div class="row">
      <div class="col-xl-4">
 
        <div class="card card-custom card-stretch gutter-b">

          <div class="card-body p-0">
            <div
              class="d-flex align-items-center justify-content-between card-spacer flex-grow-1"
            >
              <span class="symbol symbol-50 symbol-light-success mr-2">
                <span class="symbol-label">
                   <i class="fas fa-folder text-success"></i>
                </span>
              </span>
              <div class="d-flex flex-column text-right">
                <span class="text-dark-75 font-weight-bolder font-size-h3"
                  >+100</span
                >
                <span class="text-muted font-weight-bold mt-2"
                  >Demandes cette semaine</span
                >
              </div>
            </div>
          </div>

        </div>

      </div>
      <div class="col-xl-4">

        <div class="card card-custom card-stretch gutter-b">
    
          <div class="card-body p-0">
            <div
              class="d-flex align-items-center justify-content-between card-spacer flex-grow-1"
            >
              <span class="symbol symbol-50 symbol-light-primary mr-2">
                <span class="symbol-label">
                   <i class="fas fa-users text-primary"></i>
                </span>
              </span>
              <div class="d-flex flex-column text-right">
                <span class="text-dark-75 font-weight-bolder font-size-h3"
                  >+150</span
                >
                <span class="text-muted font-weight-bold mt-2"
                  >Visite cette semaine</span
                >
              </div>
            </div>
          </div>

        </div>
  
      </div>
      <div class="col-xl-4">

        <div class="card card-custom card-stretch gutter-b">
    
          <div class="card-body p-0">
            <div
              class="d-flex align-items-center justify-content-between card-spacer flex-grow-1"
            >
              <span class="symbol symbol-50 symbol-light-danger mr-2">
                <span class="symbol-label">
                   <i class="fas fa-folder text-danger"></i>
                </span>
              </span>
              <div class="d-flex flex-column text-right">
                <span class="text-dark-75 font-weight-bolder font-size-h3"
                  >+123</span
                >
                <span class="text-muted font-weight-bold mt-2"
                  >Demandes ratées cette semaine</span
                >
              </div>
            </div>
          </div>
   
        </div>

      </div>
    </div> -->

    <!-- <div class="row">
      <div class="col-xl-4">
        <div class="card card-custom card-stretch gutter-b">
          <div class="card-body p-0">
            <div
              class="
                d-flex
                align-items-center
                justify-content-between
                card-spacer
                flex-grow-1
              "
            >
              <span class="symbol symbol-50 symbol-light-warning mr-2">
                <span class="symbol-label">
                  <i class="fas fa-list text-warning"></i>
                </span>
              </span>
              <div class="d-flex flex-column text-right">
                <span class="text-dark-75 font-weight-bolder font-size-h3">{{
                  requestCount.waitingNbr
                }}</span>
                <span class="text-muted font-weight-bold mt-2"
                  >Demandes en attentes</span
                >
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-xl-4">
        <div class="card card-custom card-stretch gutter-b">
          <div class="card-body p-0">
            <div
              class="
                d-flex
                align-items-center
                justify-content-between
                card-spacer
                flex-grow-1
              "
            >
              <span class="symbol symbol-50 symbol-light-success mr-2">
                <span class="symbol-label">
                  <i class="fas fa-list text-success"></i>
                </span>
              </span>
              <div class="d-flex flex-column text-right">
                <span class="text-dark-75 font-weight-bolder font-size-h3">{{
                  requestCount.processedNbr
                }}</span>
                <span class="text-muted font-weight-bold mt-2"
                  >Demandes traitées</span
                >
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-xl-4">
        <div class="card card-custom card-stretch gutter-b">
          <div class="card-body p-0">
            <div
              class="
                d-flex
                align-items-center
                justify-content-between
                card-spacer
                flex-grow-1
              "
            >
              <span class="symbol symbol-50 symbol-light-danger mr-2">
                <span class="symbol-label">
                  <i class="fas fa-list text-danger"></i>
                </span>
              </span>
              <div class="d-flex flex-column text-right">
                <span class="text-dark-75 font-weight-bolder font-size-h3"
                  >{{ requestCount.missedNbr }}
                </span>
                <span class="text-muted font-weight-bold mt-2"
                  >Demandes ratées</span
                >
              </div>
            </div>
          </div>
        </div>
      </div>
    </div> -->
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
//import AnalyticsService from "../../services/analytics.service";
import PharmaciesService from "../../services/pharmacies.service";
import AnalyticsService from "../../services/analytics.service";

export default {
  name: "dashboard",
  components: {},
  data() {
    return {
      pharmacy: {},
      medicinesCount: {
        availableCount: 0,
        notAvailableCount: 0,
        mappedCount: 0,
        notMappedCount: 0,
        allCount: 0,
      },
      requestCount: {},
    };
  },
  created() {
    this.$availabilityHub.$on("request-notify", this.refresh);
  },
  beforeDestroy() {
    this.$availabilityHub.$off("request-notify", this.refresh);
  },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [{ title: "Dashboard" }]);

    // this.getRequestsCount();
    // this.getPharmacy();
    //  AnalyticsService.getMedicinesCount(this.currentPharmacy.guid).then(result => {
    //   this.medicinesCount = result.data;
    // });
  },
  methods: {
    getRequestsCount: function () {
      AnalyticsService.getRequestsCount(this.currentPharmacy.guid).then(
        (result) => {
          this.requestCount = result.data;
        }
      );
    },
    getPharmacy: function () {
      PharmaciesService.getPharmacy(this.currentPharmacy.guid).then(
        (result) => {
          this.pharmacy = result.data;
        }
      );
    },
    acronym: function (str) {
      if (str) {
        var matches = str.match(/\b(\w)/g);
        var acronym = matches.join("");
        return acronym;
      }
      return "";
    },
    refresh() {
      this.getRequestsCount();
    },
  },
  computed: {
    ...mapGetters(["currentPharmacy"]),
  },
};
</script>
